import React from "react";
import MainButton from "./MainButton";
import "./ProjectItem.css";

export default function ProjectItem(props) {
  return (
    <div className="project-item d-flex flex-column align-items-center justify-content-between">
      <h3>{props.headline}</h3>
      <div className="project-screen">
        <img src={props.image} alt="project screenshot" />
      </div>
      <p>{props.description}</p>
      <div className="buttons">
        <MainButton buttonHref={props.liveSiteUrl} callToAction="Live site" />
        <MainButton buttonHref={props.gitHubUrl} callToAction="GitHub" />
      </div>
    </div>
  );
}
